import React from 'react'
import { Route, Routes } from 'react-router-dom'
import LoadableComponent from '../../utils/loadable'
import { withRouter } from '../../utils/router'
import { isAuthenticated } from '../../utils/session'

const Flowchart = LoadableComponent(() => import('../../containers/Manage/Design/Flowchart/index'))
const Mindmap = LoadableComponent(() => import('../../containers/Manage/Design/Mindmap/index'))
const Whiteboard = LoadableComponent(() => import('../../containers/Manage/Design/Whiteboard/index'))
const Sysarc = LoadableComponent(() => import('../../containers/Manage/Design/Sysarc/index'))
const Orgarc = LoadableComponent(() => import('../../containers/Manage/Design/Orgarc/index'))
const Other = LoadableComponent(() => import('../../containers/Manage/Design/Other/index'))

const TemplateCreated = LoadableComponent(() => import('../../containers/Manage/Template/Created/index'))
const TemplateFavorite = LoadableComponent(() => import('../../containers/Manage/Template/Favorite/index'))

const LibraryCreated = LoadableComponent(() => import('../../containers/Manage/Library/Created/index'))
const LibraryFavorite = LoadableComponent(() => import('../../containers/Manage/Library/Favorite/index'))

class ManageMain extends React.Component {

    render() {
        return (
            <div style={{ padding: 16, position: 'relative' }}>
                <Routes>
                    <Route path='/design/flowchart' element={<Flowchart />} />
                    <Route path='/design/mindmap' element={<Mindmap />} />
                    <Route path='/design/whiteboard' element={<Whiteboard />} />
                    <Route path='/design/sysarc' element={<Sysarc />} />
                    <Route path='/design/orgarc' element={<Orgarc />} />
                    <Route path='/design/other' element={<Other />} />
                    <Route path='/design/*' element={<Flowchart />} />
                    <Route path='/template/created' element={<TemplateCreated />} />
                    <Route path='/template/favorite' element={<TemplateFavorite />} />
                    <Route path='/template/*' element={<TemplateCreated />} />
                    <Route path='/library/created' element={<LibraryCreated />} />
                    <Route path='/library/favorite' element={<LibraryFavorite />} />
                    <Route path='/library/*' element={<LibraryCreated />} />
                    <Route path='/*' element={<Whiteboard />} />
                </Routes>
            </div>
        )
    }
}

export default withRouter(ManageMain)